import React from "react";

const QUEST_PATHS = [
  "M315 2579 c-217 -70 -324 -316 -227 -523 59 -126 175 -207 320 -223 l72 -8 -38 -75 c-21 -41 -71 -130 -110 -196 -202 -341 -273 -565 -276 -864 -1 -134 2 -164 21 -225 57 -180 193 -326 368 -396 l60 -24 680 -3 c482 -2 697 0 740 8 130 25 254 119 311 235 25 51 29 72 29 140 0 71 -4 89 -32 145 -36 74 -103 147 -165 184 -82 48 -141 56 -405 56 -188 0 -243 3 -243 13 0 6 19 50 43 97 40 81 46 87 137 152 52 36 160 106 240 154 172 103 301 191 419 286 99 79 289 265 327 319 30 44 26 76 -11 85 -30 7 -239 -12 -325 -30 -36 -8 -66 -13 -68 -11 -1 1 9 26 22 56 41 89 60 176 61 279 0 86 -3 101 -31 160 -53 112 -119 171 -232 209 -60 21 -79 21 -844 20 -748 0 -786 -1 -843 -20z m1285 -106 c-18 -20 -47 -67 -64 -103 -27 -58 -31 -75 -31 -155 0 -77 4 -98 28 -149 15 -33 44 -79 63 -103 l36 -44 -644 3 c-608 3 -645 4 -678 22 -68 37 -109 77 -139 138 -26 51 -31 73 -31 132 0 121 56 212 162 265 l61 31 635 0 634 0 -32 -37z m418 6 c103 -51 153 -129 160 -250 6 -96 -23 -214 -76 -313 l-38 -71 -130 -65 c-153 -76 -258 -152 -369 -265 -158 -161 -294 -389 -371 -622 -39 -119 -40 -157 -3 -168 17 -6 33 6 84 62 l63 68 -19 -70 c-26 -91 -35 -262 -20 -338 20 -95 73 -187 147 -256 l65 -62 -503 3 -503 3 -68 32 c-124 59 -229 182 -277 323 -21 60 -22 78 -17 225 11 296 70 469 285 834 50 84 102 181 118 216 l27 65 660 0 c601 0 662 2 679 17 38 34 9 67 -69 76 -231 26 -334 310 -179 494 15 17 54 46 88 62 51 26 73 31 133 31 60 0 82 -5 133 -31z m107 -747 c-225 -116 -416 -255 -597 -432 -108 -106 -104 -86 13 63 146 185 380 343 610 411 46 14 89 25 94 25 6 0 -48 -30 -120 -67z m205 -44 c-98 -93 -278 -230 -400 -306 -47 -29 -142 -88 -212 -131 -69 -43 -163 -106 -207 -139 -45 -34 -81 -57 -81 -52 0 17 243 261 325 327 160 128 356 248 553 338 53 24 99 44 102 44 3 0 -33 -36 -80 -81z m-734 -1011 c-36 -45 -86 -141 -86 -167 0 -28 -23 -40 -76 -40 l-52 0 -7 39 c-6 37 -1 117 11 184 l6 27 119 0 120 0 -35 -43z m378 27 c63 -22 148 -101 182 -170 22 -46 26 -64 22 -122 -3 -56 -9 -77 -37 -120 -40 -64 -94 -107 -169 -138 -103 -42 -261 -28 -376 34 -59 31 -146 113 -170 160 l-17 32 41 0 c74 0 124 40 146 116 49 170 218 262 378 208z",
  "M360 2417 c-74 -24 -147 -129 -126 -183 12 -31 58 -13 85 34 28 46 61 71 99 72 22 0 62 32 62 49 0 19 -32 41 -58 40 -15 -1 -43 -6 -62 -12z",
  "M576 2415 c-42 -42 1 -75 96 -75 55 0 72 4 89 21 18 18 19 23 6 42 -12 19 -25 22 -95 25 -63 2 -83 -1 -96 -13z",
  "M503 1431 c-61 -39 -77 -59 -67 -86 13 -32 50 -28 109 11 l57 38 48 -27 c62 -35 113 -35 162 -2 20 14 42 25 48 25 6 0 28 -11 48 -25 49 -33 100 -33 162 2 l48 27 57 -38 c62 -41 98 -43 110 -6 9 27 1 36 -68 81 -74 48 -118 51 -186 12 l-48 -26 -39 26 c-53 37 -115 37 -168 0 l-39 -26 -48 26 c-68 39 -112 36 -186 -12z",
  "M433 1165 c-65 -28 -123 -75 -123 -98 0 -26 17 -47 37 -47 8 0 37 16 66 35 28 19 58 35 65 35 7 0 30 -11 50 -25 24 -16 50 -25 77 -25 27 0 53 9 77 25 45 31 53 31 103 0 23 -14 55 -25 75 -25 20 0 52 11 75 25 22 13 46 25 53 25 7 0 37 -16 66 -36 58 -38 90 -39 101 -5 9 29 -2 44 -66 85 -74 48 -117 51 -182 12 l-45 -26 -58 30 c-65 35 -91 34 -161 -7 l-42 -24 -38 25 c-50 32 -91 39 -130 21z",
  "M290 793 c-65 -46 -79 -66 -64 -90 18 -29 43 -27 100 11 29 20 59 36 64 36 6 0 28 -11 48 -25 49 -33 100 -33 162 2 l47 27 46 -27 c59 -35 105 -35 167 0 l48 27 56 -37 c60 -40 75 -44 94 -25 28 28 13 57 -50 98 -76 49 -120 52 -186 14 l-46 -27 -47 27 c-60 33 -106 33 -167 -1 l-48 -27 -39 27 c-60 41 -117 37 -185 -10z",
];

export default function QuestIcon({
  size = 50,
  color = "#39210d",
  onClick,
  className,
  style = {},
  ...rest
}) {
  const visualHeight = Math.max(1, size - 2);
  const scaleY = visualHeight / size;
  const mergedStyle = Object.assign(
    {
      width: size,
      height: size,
      overflow: "hidden",
      cursor: onClick ? "pointer" : undefined,
    },
    style
  );

  const svgProps = {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 262 268",
    width: size,
    height: size,
    fill: color,
    overflow: "hidden",
    onClick,
    className,
    style: mergedStyle,
    ...rest,
  };

  return React.createElement(
    "svg",
    svgProps,
    React.createElement(
      "g",
      { transform: `translate(131 134) scale(1 ${scaleY}) translate(-131 -134)` },
      React.createElement(
        "g",
        { transform: "translate(0,268) scale(0.1,-0.1)", fill: color, stroke: "none" },
        QUEST_PATHS.map((d, index) =>
          React.createElement("path", { key: index, d })
        )
      )
    )
  );
}
